/**
 * Sync Status Constants
 * Centralized constants for device sync status values
 */
export const SYNC_STATUS = {
  IN_PROGRESS: "in-progress",
  COMPLETED: "completed",
  FAILED: "failed",
  COMPLETED_PARTIALLY_CACHED: "completed-partially-cached",
};

export default SYNC_STATUS;

